import Vue from 'vue';
import './plugins/vuetify'
import moment from 'vue-moment';
Vue.use(moment);

// Add polyfills for forEach for IE for for for for
if (window.NodeList && !NodeList.prototype.forEach) {
	NodeList.prototype.forEach = Array.prototype.forEach;
}

import Homepage from './pages/Homepage.vue';
import CommissionerLandingPage from './pages/CommissionerLandingPage.vue';
import CommissionerDetailPage from './pages/CommissionerDetailPage.vue';
import EventCalendar from './components/Events/EventCalendar.vue';
import NewsArticlePage from './pages/NewsArticlePage.vue';
import NewsroomLandingPage from './pages/NewsroomLandingPage.vue';
import SpringboardPage from './pages/SpringboardPage.vue';
import SearchResults from './components/Search/SearchResults.vue';
import DocumentResults from './components/Search/DocumentResults.vue';
import HowToStepsPage from './pages/HowToStepsPage.vue';
import EventDetailPage from './pages/EventDetailPage.vue';

Vue.config.productionTip = false;
Vue.prototype.$projectRoot = '';

let componentInitializers = [
	{
		selector: '.commissioner-landing-page',
		vueComponent: CommissionerLandingPage
    },
    {
        selector: '.springboard-vue',
        vueComponent: SpringboardPage
    },
    {
        selector: '.news-article-vue',
        vueComponent: NewsArticlePage
    },
    {
        selector: '.newsroom-landing-vue',
        vueComponent: NewsroomLandingPage
    },
    {
        selector: '.commissioner-detail-page',
        vueComponent: CommissionerDetailPage
    },
    {
        selector: '#homepage',
        vueComponent: Homepage
    },
    {
        selector: '#eventCalendar',
        vueComponent: EventCalendar
	},
    {
        selector: '#searchResults',
        vueComponent: SearchResults
    },
    {
        selector: '#documentResults',
        vueComponent: DocumentResults
    },
    {
        selector: '#howToStepsPage',
        vueComponent: HowToStepsPage
    },
    {
        selector: '.event-detail-page',
        vueComponent: EventDetailPage
    }
]

componentInitializers.forEach(function(component) {
	
	let elements = document.querySelectorAll(component.selector);
	
	if (elements.length) {
	
		elements.forEach(function(element) {
			
			let vueMountedElement = element.querySelector('.vue');
			
			if (vueMountedElement) {
				
				new Vue({
					render: function(createElement) {
						return createElement(component.vueComponent);
					}
                }).$mount(vueMountedElement);
			}
			else {
				new Vue({
					render: function(createElement) {
						return createElement(component.vueComponent);
					}
                }).$mount(element);
			}
		});
	}
});